import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/memberRides/pageBikeLog', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/memberRides/exportBikeLogExcel', data, {
    trim: true,
    download: true
  })
}

